import React, {Component} from 'react';
import {Form} from "antd";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import "./index.less";

import actions from "Actions/taskManage/monitoring";
import ReactEcharts from 'echarts-for-react';
import moment from "moment";
import EmptyImg from "Static/images/empty.png";

class ChartItem extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      projectData: [],
      dateStr: '',
      taskId:''
    };
    this.timer=null;
  }
  componentDidMount() {
    const {Actions} = this.props;
    // 延时10S请求一次数据，保证数据的准确性
    this.timer=setInterval(() => {
      const {dateStr,taskId} = this.state;
      let params = {
        taskId:taskId,
        minuteStr:dateStr
      };
      if(moment(dateStr).isBefore(moment().subtract(2, 'minutes'))){
        Actions.postCallbackByProId(params);
      }
    }, 10000);

  }

  componentWillReceiveProps(nextProps, nextContext) {
    // 根据接口返回数据，获取最后数据的时间，加1分钟，作为下一次请求接口的入参
    // 合并数组
    if (nextProps.taskManageMonitoring.taskMonitoringList !== this.props.taskManageMonitoring.taskMonitoringList) {

      const {projectData, dateStr,taskId} = this.state;
      let time = dateStr;
      let taskIdNew=taskId;
      let dataNew = [];
      let data = nextProps.taskManageMonitoring.taskMonitoringList;
      if (data.length > 0 && data[data.length - 1].minuteStr) {
        let lastTime = data[data.length - 1].minuteStr;
        time = moment(lastTime).add(1, 'minutes').format('YYYY-MM-DD HH:mm:00');
      }else{
        time='';
      }
      // 判断请求类型，请求全部，则替换，否则，追加
      if(taskId!=nextProps.taskManageMonitoring.taskMonitoringId){
        taskIdNew=nextProps.taskManageMonitoring.taskMonitoringId;
        dataNew = nextProps.taskManageMonitoring.taskMonitoringList;
      }else{
        dataNew = dataNew.concat(projectData, nextProps.taskManageMonitoring.taskMonitoringList);
      }
      this.setState({
        projectData: dataNew,
        dateStr: time,
        taskId:taskIdNew
      })
    }
  }
  componentWillUnmount(){
    clearInterval(this.timer);
  }

  getOption = (data) => {
    let summaryTime = [],  // 时间汇总x
      commitNumList = [],  // 分钟提交量
      notCallNumList = [],  // 剩余未呼叫量
      callingNumList = [],  // 正在呼叫量
      notCallbackNumList = [];  // 剩余未回调量
    let lineData = [];
    if (Array.isArray(data) && data.length > 0) {
      data.map((item) => {
        summaryTime.push(item.minuteStr);
        commitNumList.push(item.commitNum); //分钟提交量
        notCallNumList.push(item.notCallNum); // 剩余未呼叫量
        callingNumList.push(item.callingNum);  // 正在呼叫量
        notCallbackNumList.push(item.notCallbackNum);  // 剩余未回调量
      })
      lineData.push(commitNumList, notCallNumList,callingNumList,notCallbackNumList)
    }

    let colors = ['#40aefc', '#5bd998', '#ffd257', '#485c97'],
      names = ['分钟提交量', '剩余未呼叫量', '正在呼叫量', '剩余未回调量'],
      seriesData = [];
    names.map((item, index) => {
      seriesData.push({
        name: item,
        type: "line",
        smooth: true,
        data: lineData[index] || [],
        itemStyle: {
          normal: {
            borderWidth: 5,
            color: colors[index],
          }
        }
      })
    })
    const option = {
      title: {
        top: '0',
        left: '0',
        text: '全天数据动态图',
        textStyle: {
          color: '#191F25',
          fontSize: 14,
        }
      },
      legend: {
        top: '0',
        right: '40',
        textStyle: {
          color: '#191F25',
          fontSize: 12,
        },
        data: names
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'line',
        },
        formatter: function (params) {

          let htmlStr = '<div style="color: #191F25">';

          htmlStr += '<div style="font-size: 14px; padding-bottom: 5px;">' + moment(params[0].name).format('HH:mm') + '</div>';//x轴的名称;
          params.map((item) => {
            let color = item.color;//图例颜色
            //为了保证和原来的效果一样，这里自己实现了一个点的效果
            htmlStr += '<div style="font-size: 12px; color: #191F25; "><span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:' + color + ';"></span>';

            htmlStr += item.seriesName + '：' + item.value + '</div>';
          })
          htmlStr += '</div>';
          return htmlStr
        },
        backgroundColor: '#FFF',
        padding: 12,
        extraCssText: 'box-shadow: 0 4px 8px 0 rgba(0,0,0,0.15);'
      },
      dataZoom: [
        {
          type: 'slider',
          show: true,
          height: 20,
          left: '10%',
          right: '10%',
          bottom: '2%',
          start: 90,
          end: 100,
          filterMode: 'empty',
          textStyle: {
            color: '#ff6b66',
            fontSize: 12,
          },
        }, {
          type: 'inside'
        }
      ],
      grid: {
        right: '5%',
        bottom: '10%',
        left: '2%',
        top: '80px',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          data: summaryTime,
          name: '时间',
          nameTextStyle: {
            color: '#53626F'
          },
          axisLine: {
            lineStyle: {
              color: '#979797'
            }
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#53626F",
              fontSize: 12,
              lineHeight: 20,
            },
            margin: 15,
            formatter: function (value) {
              let tmpStr = moment(value).format('HH:mm') + "\n";
              tmpStr += moment(value).format('MM-DD');
              return tmpStr
            }
          },
        }
      ],
      yAxis: [{
        type: 'value',
        name: '次数',
        nameTextStyle: {
          color: '#53626F'
        },
        position: 'left',
        axisLine: {
          lineStyle: {
            color: '#979797'
          }
        },
        minInterval: 1,
        axisTick: {
          show: false,
        },
        splitLine: {
          lineStyle: {
            color: "#CCCCCC",
            opacity: 0.75,
          }
        },
        axisLabel: {
          color: '#53626F',
          fontSize: 12,
        },
        max: function(value) {
          return value.max + 20;
        },
      },],


      series: seriesData,
    }
    return option;
  }


  render() {
    const {projectData} = this.state;
    return (
      <div className="proC-chart-wrap">
        {projectData.length > 0 ?
          <ReactEcharts
            option={this.getOption(projectData)}
            style={{width: '100%', height: window.innerHeight - 52 - 72 - 100}}
            className='react_for_echarts'/>
          : <div className='empty-tips'>
            <img src={EmptyImg}/>
            <div>暂无数据</div>
          </div>}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  taskManageMonitoring: state.taskManageMonitoring,
});

const mapDispatchToProps = dispatch => {
  return {
    Actions: bindActionCreators(actions, dispatch)
  };
};

export default connect(mapStateToProps,mapDispatchToProps)(Form.create()(ChartItem));
